import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "@/store/store";
import { BrowserRouter, Route } from "react-router-dom";
import React from "react";
import { ToastProvider } from "uikit";

const renderReactComponent = (id, component, path, data) => {
    const element = document.getElementById(id);
    if (element) {
        const root = createRoot(element);
        root.render(
            <Provider store={store}>
                <BrowserRouter>
                    <ToastProvider>
                        <Route path={path} component={component} data={data} />
                    </ToastProvider>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default renderReactComponent;
